import React from 'react'

import { PageTemplate, HomeTemplate } from '../../templates'

const Home: React.FC = () => {
  return (
    <PageTemplate>
      <HomeTemplate />
    </PageTemplate>
  )
}

export default Home
